import { Box, Card, CircularProgress, Tooltip, Typography, IconButton } from "@mui/material";
import { PersonRemove, Person } from "@mui/icons-material";
import { useChatPdVContext } from "../../../../contexts/atendimento/ChatPdVContext";
import { alpha } from "@mui/material/styles";
import { contorno, cores, limitarLinhas, raio, superficie, texto } from "../../identidade";

export const ChatPdVClienteVinculado = () => {
    const { cliente, desvincularClienteDoChat, loadingCliente } = useChatPdVContext();

    if (!cliente) return null;

    return (
        <Card
            elevation={0}
            sx={{
                px: 1.5,
                py: 1.5,
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexShrink: 0,
                borderRadius: raio.md,
                backgroundColor: theme => superficie(theme, 0.03),
                border: theme => contorno(theme, 0.08),
                backgroundImage: 'none',
            }}
        >
            <Box
                sx={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    backgroundColor: alpha(cores.marca[500], 0.14),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                <Person sx={{ color: cores.marca[500], fontSize: 19 }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ ...texto.titulo, ...limitarLinhas(1) }}>
                    {cliente.nome}
                </Typography>
                {cliente.telefone && (
                    <Typography color="text.secondary" sx={{ ...texto.apoio, mt: 0.25, ...limitarLinhas(1) }}>
                        {cliente.telefone}
                    </Typography>
                )}
            </Box>
            {loadingCliente ? (
                <CircularProgress size={20} />
            ) : (
                <Tooltip title="Remover cliente">
                    <IconButton
                        onClick={desvincularClienteDoChat}
                        sx={{
                            width: 36,
                            height: 36,
                            color: cores.sinal[500],
                            backgroundColor: 'rgba(244, 63, 94, 0.08)',
                            borderRadius: 2,
                            '&:hover': {
                                backgroundColor: 'rgba(244, 63, 94, 0.15)',
                            },
                        }}
                    >
                        <PersonRemove sx={{ fontSize: 20 }} />
                    </IconButton>
                </Tooltip>
            )}
        </Card>
    );
};
